<template>
	<div class="pay" v-loading.fullscreen.lock="loading">
		<banner></banner>
		<div class="wrap">
			<div class="pkgInfo">
				<table border="0" cellspacing="0" cellpadding="" v-if="pkgNow" class="hidden-xs-only">
					<tr>
						<td v-if="activeFlag=='offline'" valign="top" style="text-align: right;">+852 {{msisdn}}</td>
						<td style="text-align: right;" valign="top">{{$i18n.locale=='zh'?'大流量服务组合':'大流量服務組合'}}</td>
						<td style="text-align: center;" valign="top">
							<div class="des">
								<p><span>{{pkgNow.flow}}GB</span>{{pkgNow.des[0]}}</p>
								<p><span>{{pkgNow.time_hk}}分钟</span>{{pkgNow.des[1]}}</p>
								<p><span>{{pkgNow.time_ch}}分钟</span>{{pkgNow.des[2]}}</p>
							</div>
						</td>
						<td valign="top">
							<p class="big">HK${{pkgNow.price}}</p>
							<del>HK${{pkgNow.oldprice}}</del>
						</td>
					</tr>
				</table>
				<table border="0" cellspacing="0" cellpadding="" v-if="pkgNow" class="hidden-sm-and-up tb-m">
					<tr v-if="activeFlag=='offline'">
						<td>+852 {{msisdn}}</td>
					</tr>
					<tr>
						<td>{{$i18n.locale=='zh'?'大流量服务组合':'大流量服務組合'}}</td>
					</tr>
					<tr>
						<td>
							<div class="des">
								<p class="tit">包含内容：</p>
								<p><span>{{pkgNow.flow}}GB</span>{{pkgNow.des[0]}}</p>
								<p><span>{{pkgNow.time_hk}}分钟</span>{{pkgNow.des[1]}}</p>
								<p><span>{{pkgNow.time_ch}}分钟</span>{{pkgNow.des[2]}}</p>
							</div>
						</td>
					</tr>
					<tr>
						<td valign="top">
							<p class="big">HK${{pkgNow.price}}</p>
							<del>HK${{pkgNow.oldprice}}</del>
						</td>
					</tr>
				</table>
			</div>
			<div class="payCon clearfix">
				<p class="title">{{$t('pay.title')}}</p>
				<div class="payType clearfix">
					<el-radio v-model="type" label="1">
						<img src="../../static/images/z-pay-visa.jpg"/>
					</el-radio>
					<el-radio v-model="type" label="2">
						<img src="../../static/images/z-pay-yl2.png"/>
					</el-radio>
					<el-radio v-model="type" label="3">
						<img src="../../static/images/z-pay-paypal.jpg"/>
					</el-radio>
					<el-radio v-model="type" label="4">
						<img src="../../static/images/z-pay-zfb.jpg"/>
					</el-radio>
				</div>
				<p class="pay_btn"><a href="javascrpt:void(0)" @click="doPay">{{$t('btn.next')}}</a></p>
				<!-- PAYPAL -->
				<form name="paypalForm" id="paypalForm" action ="#" method="post">
			        <input type="hidden" name="cmd" value="_s-xclick"/>
			        <input type="hidden" name="charset" value="payPal.charset" />
			        <input type="hidden" name="encrypted" v-model="payPal.encrypted"/>
		        </form>
		        <!-- 银行卡/银联 -->
		        <form name="payFormCcard" id="payFormCcard" action ="#" method="post">
			        <input type="text" name="merchantId" v-model="card.merchant_id">
			        <input type="hidden" name="amount" v-model="card.amount">
			        <input type="hidden" name="orderRef" v-model="card.pay_order_id">
			        <input type="hidden" name="currCode" v-model="card.curr_code">
			        <input type="hidden" name="mpsMode" v-model="card.mps_mode">
			        <input type="hidden" name="successUrl" v-model="card.success_url">
			        <input type="hidden" name="failUrl" v-model="card.fail_url">
			        <input type="hidden" name="cancelUrl" v-model="card.cancel_url">
			        <input type="hidden" name="payType" v-model="card.pay_type">
			        <input type="hidden" name="lang" v-model="card.lang">
			        <input type="hidden" name="remark" v-model="card.remark">
			        <input type="hidden" name="secureHash" v-model="card.secure_hash">
			        <input type="hidden" name="payMethod" v-model="card.pay_method">
		        </form>
	        </div>
        </div>
        <footer>{{$t('footer')}}</footer>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { getPayLink,toPay } from '@/api/api'
import banner from '@/components/banner'
export default {
  name: 'payConfirm',
  components: {
  	banner
  },
  data () {
    return {
     	type: '1',
     	loading: false,
     	errMsg: {
     		'1': '该订单已失效，请重新订购',
     		'2': '已订购过该套餐，请勿重复订购',
     		'3': '该订单已被关闭',
     		'4': '系统异常，请稍后重试'
     	},
     	card: {},
     	payPal: {},
     	msisdn: '',//用户号码
     	key_iccid: '148f5e153ef24b5bb9db599c7b9f66d7',//加密钥匙
    }
  },
  computed: {
  	...mapState('param',['gutter']),
	order_id () {
		return this.$store.state.param.order_id
	},
  	activeFlag () {
  		return this.$store.state.param.activeFlag
  	},
  	bundlecode () {//套餐id
  		return this.$route.query.bundlecode
  	},
  	iccid () {
  		return this.$store.state.param.iccid
  	},
  	pkgList () {//套餐详细信息
  		return this.$i18n.locale == 'zh'?require('@/common/json/pkgList'): require('@/common/json/pkgList_hk')
  	},
  	pkgNow () {//当前选中的套餐
  		if(this.bundlecode){
  			return this.pkgList.filter(v => {return v.bundlecode == this.bundlecode})[0]
  		}
  	},
  },
  methods: {
  	doPay () {
  		let param = {}
  		param.type = this.type
  		param.url = 'https://images.ctexcel.com.hk/activity/student/#/payResult?pay_type=' + this.type
  		//param.url = 'http://192.168.0.105:8888/#/payResult?pay_type=' + this.type
  		param.order_id = this.order_id
  		if(this.type == '1'||this.type == '2'){
  			param.url_cancel = 'https://images.ctexcel.com.hk/activity/student/#/payResult?pay_type=' + this.type + '&result_type=0'
  			//param.url_cancel = 'http://192.168.0.105:8888/#/payResult?pay_type=' + this.type + '&result_type=0'
  			param.url_fail = 'https://images.ctexcel.com.hk/activity/student/#/payResult?pay_type=' + this.type + '&result_type=0'
  			//param.url_fail = 'http://192.168.0.105:8888/#/payResult?pay_type=' + this.type + '&result_type=0'
  		}
  		param.bundlecode = this.bundlecode
  		console.log(param)
  		this.loading = true
  		//将支付方式存入session
  		//window.sessionStorage.setItem('pay_type', this.type)
  		//获取支付链接
		getPayLink (param) 
		.then( res => {
			console.log(res)
			if(res.code == 0){//成功 跳转支付链接
				if(this.type == '1'||this.type == '2'){//银行卡 银联
					new Promise((resolve,reject) => {
						//给card对象赋值(一定要用$set赋值，否则v-model不会实时更新数据，因为最初定义了空对象，属性并不存在)
                        for(let key in res){
                        	this.$set(this.card, key, res[key])
							//this.card[key] = res[key]
						}
                    	document.getElementById('payFormCcard').action = res.action_url
                    	resolve()
                    })
                    .then(() => {
//                  	let its = document.getElementById('payFormCcard').getElementsByTagName('input')
//                  	for(var i=0;i<its.length;i++){
//                  		console.log(its[i].value)
//                  	}
//                  	console.log(this.card)
						document.getElementById('payFormCcard').submit()
                    })
				}else if(this.type == '4'){//支付宝
					window.location.href = res.action_url
				}else if(this.type == '3'){//PayPal
					new Promise((resolve,reject) => {
						//给payPal对象赋值
                        for(let key in res){
                        	this.$set(this.payPal, key, res[key])
						}
                    	document.getElementById('paypalForm').action = res.action_url
                    	resolve()
                    })
                    .then(() => {
						document.getElementById('paypalForm').submit()
                    })
				}
			}else{
				this.loading = false
				//弹出错误提示
				this.$alert(this.errMsg[res.code], '提示', {
		  			confirmButtonText: this.$t('btn.sure'),
		  		})
			}
		})
		.catch(err => {
			this.loading = false
			console.log(err)
		})
  	},
 },
 created () {
 	//存vuex订单号
  	if(sessionStorage.getItem('order_id')){
  		this.$store.commit('param/setOrderId', sessionStorage.getItem('order_id'))
	}
  	//存vuex活动标识（online 线上 offline 线下）
  	if(sessionStorage.getItem("activeFlag")){
  		this.$store.commit('param/setActiveFlag', sessionStorage.getItem('activeFlag'))
  	}
  	//从路由参数中读取iccid
  	if(this.$route.params.iccid){
  		this.$store.commit('param/setIccid', this.$route.params.iccid)
  	}
  	//从官网跳到支付页，在URL中读取iccid
  	if(this.$route.query.iccid){
  		//解密iccid
  		let encrypt_iccid = decodeURIComponent(this.$route.query.iccid)
  		console.log(encrypt_iccid)
  		let CryptoJS = require("crypto-js")
  		let decrypt_iccid = CryptoJS.AES.decrypt(encrypt_iccid, this.key_iccid).toString(CryptoJS.enc.Utf8)
  		this.$store.commit('param/setIccid', decrypt_iccid)
  	}
//	let CryptoJS = require("crypto-js")
//	let encrypt_str = CryptoJS.AES.encrypt("80111000222", this.key).toString()
//	let decrypt_str = CryptoJS.AES.decrypt(encrypt_str, this.key).toString(CryptoJS.enc.Utf8)
//	console.log(encrypt_str)
//	console.log(decrypt_str)
  	
  	//如果是从官网跳转来的链接，需要带活动标志offline
  	if(this.$route.query.activeFlag){
  		this.$store.commit('param/setActiveFlag', this.$route.query.activeFlag)
  	}
  	//如果是线下流程，才走接口调数据
  	console.log(this.activeFlag)
  	if(this.activeFlag == 'offline'){
  		this.loading = true
	  	//调取toPay 接口,获取order_id和手机号码
	  	console.log(this.iccid)
	  	toPay({iccid: this.iccid})
	  	.then(res => {
	  		this.loading = false
	  		console.log(res)
	  		if(res.code == '0'){//成功
	  			//存号码
	  			this.msisdn = res.msisdn
	  			//存vuex 订单号
	  			this.$store.commit('param/setOrderId', res.order_id)
	  		}else{
	  			//弹出提示，返回首页
				this.$msgbox({
					title: '提示',
					message: this.$i18n.locale=='zh'?'系统繁忙，请返回首页~':'系統繁忙，請返回首頁~',
					showCancelButton: false,
					confirmButtonText: this.$t('btn.sure'),
					callback: action => {
			            this.$router.push({ name: 'index' })
			        }
				})
	  		}
	  	})
	  	.catch(err => {
	  		this.loading = false
	  		console.log(err)
	  	})
  	}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.pay_btn{
	text-align: center;
	a{
		display: inline-block;
		padding: 0 50px;
		font-size: 16px;
		line-height: 50px;
		border-radius: 4px;
		background: #f96e4c;
		color: #fff;
  		background-image: linear-gradient( 0deg, rgb(243,75,63) 0%, rgb(250,118,79) 100%);
	}
}
.pkgInfo{
	table{
		width: 100%;
		background-color: #f2f6f7;
		font-size: 14px;
		color: #333;
		padding-top: 25px;
		padding-bottom: 20px;
		span{
			font-weight: 700;
		}
		.big{
			font-size: 24px;
			font-weight: 700;
			color: #f0850c;
		}
		del{
			color: #999;
		}
		.des{
			display: inline-block;
			text-align: left;
		}
	}
}
.payCon{
	.title{
		float: left;
		width: 25%;
		font-size: 18px;
		color: #393838;
		line-height: 20px;
		box-sizing: border-box;
		&:before{
			content: "";
			display: inline-block;
			width: 3px;
			height: 20px;
			background: #0842ad;
			vertical-align: top;
			margin-right: 12px;
		}
	}
	.payType{
		float: left;
		width: 75%;
	}
}
footer{
	text-align: center;
	line-height: 55px;
	font-size: 12px;
	color: #999;
}
.tb-m{
	padding-left: 3.25rem;
	padding-top: 0.75rem!important;
	padding-bottom: 0.5rem!important;
	.tit{
		float: left;
		margin-bottom: 2rem;
	}
	p{
		line-height: 0.75rem;
	}
	.des{
		display: block!important;
	}
	td{
		padding-bottom: 0.25rem;
	}
}
@media (min-width:768px) {/*pc*/
	.wrap{
		box-sizing: border-box;
		width: 1000px;
		margin: 0 auto;
		padding: 0 40px;
	}
	.pkgInfo,.payCon{
		padding: 0 40px;
	}
	.payCon{
		padding-top: 50px;
		.title{
			padding-left: 20px;
			box-sizing: border-box;
		}
	}
	.pay_btn{
		margin-bottom: 100px;
	}
}
@media (max-width:767px) {/*phone*/
	.wrap{
		padding: 0 15px;
		width: 100%;
		box-sizing: border-box;
	}
	.pkgInfo{
		margin-top: 1rem;
		margin-bottom: 1rem;
		table{
			font-size: 0.6rem;
			.big{
				font-size: 0.9rem;
			}
		}
	}
	.payCon{
		.title{
			width: 100%;
			margin-bottom: 0.8rem;
			
		}
		.payType{
			width: 100%;
			img{
				width: 65%;
			}
		}
	}
	.pay_btn{
		a{
			margin-top: 2rem;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/payConfirm.vue